// extracted by mini-css-extract-plugin
module.exports = {"input":"_base-input-custom-item_input_2uwiV","wrapper":"_base-input-custom-item_wrapper_29Vbr","icon":"_base-input-custom-item_icon_3Rfxu"};